import app from 'flarum/common/app';

app.initializers.add('marchccc/flarum-ext-mentions-group-users', () => {
  console.log('[marchccc/flarum-ext-mentions-group-users] Hello, forum and admin!');
});
